import styled from "styled-components";
import { Typography } from "@mui/material";
import PrivyIcon from "@assets/svg/privyIcon.svg?react";

export interface IDirectionProps {
  $isRtl: boolean;
}

export const CardContainer = styled.div<IDirectionProps>`
  display: flex;
  align-items: start;
  flex-direction: column;
  min-width: 320px;
  height: 235px;
  border: 1px solid #E3E8EF;
  border-radius: 12px;
  padding-block: 16px;
  box-sizing: border-box;
`;

export const CardHeader = styled.span`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
`;

export const IconWrapper = styled.div`
  width: 52px;
  height: 52px;
  margin-inline: 24px;
`;

export const StyledPrivyIcon = styled(PrivyIcon)`
  width: 52px;
  height: 52px;
`;

export const AppIcon = styled.img`
  border-radius: 8px;
  width: 52px;
  height: 52px;
`;

export const ComingSoonBadge = styled(Typography).attrs({
  sx: {
    marginInline: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "80px",
    height: "27px",
    borderRadius: "33px",
    color: "#FFFFFF",
    backgroundColor: "#5B3FFF",
    cursor: "pointer",
  },
})``;

export const CardTitle = styled.h3`
  font-weight: 700;
  font-size: 16px;
  color: #121926;
  padding-inline: 24px;
  margin-block: 0;
  height: 24px;
  padding-top: 8px;
  cursor: pointer;
`;

export const CardDescription = styled.p<IDirectionProps>`
  font-weight: 400;
  font-size: 14px;
  color: #475467;
  padding-inline: 24px;
  margin-block: 0;
  margin-top: 16px;
  height: ${(props) => (props.$isRtl ? "60px" : "70px")};
  margin-bottom: 14px;
`;

export const ActivateButton = styled.span`
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  color: #5B3FFF;
  width: 100%;
  border-top: 1px solid #E3E8EF;
  margin-block: 0;
  padding-top: 16px;
  cursor: pointer;
`;

// Skeleton specific styles
export const BadgeSkeletonWrapper = styled.div`
  margin-inline: 10px;
`;

export const TitleSkeletonWrapper = styled.div`
  width: 100%;
  padding-inline: 24px;
  padding-top: 8px;
`;

export const DescriptionSkeletonWrapper = styled.div<IDirectionProps>`
  width: 100%;
  padding-inline: 24px;
  margin-top: 16px;
  height: ${(props) => (props.$isRtl ? "60px" : "70px")};
  margin-bottom: 14px;
`;

export const ActivateSkeletonWrapper = styled.div`
  height: 54px;
  width: 100%;
  border-top: 1px solid #E3E8EF;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 16px;
`;